import { config } from "../config";
import { TPlan } from "../utils/types";
import { TPlanGetResponse } from "./api";

const protocol = config.coreApi.protocol;
const host = config.coreApi.host;
const billingBaseUrl = `${protocol}://${host}/clinics/v1/billing`;

const buildHeaders = (apiKey: string) => ({
  "Content-Type": "application/json",
  "X-Clinic-Api-Key": apiKey,
});

const extractErrorMessage = async (response: Response) => {
  if (response.status === 401) {
    return "API key is invalid or has expired.";
  }
  if (response.status === 403) {
    return "API key is missing the required billing:manage scope.";
  }
  const text = await response.text();
  return text || `HTTP error ${response.status}`;
};

export const getBillingSummaryWithApiKey = async (
  apiKey: string,
  clinicUuid: string,
): Promise<TPlanGetResponse> => {
  const response = await fetch(`${billingBaseUrl}/${clinicUuid}/payments`, {
    method: "GET",
    headers: buildHeaders(apiKey),
  });

  if (!response.ok) {
    const message = await extractErrorMessage(response);
    throw new Error(message);
  }

  return (await response.json()) as TPlanGetResponse;
};

export const updatePlanWithApiKey = async (
  apiKey: string,
  clinicUuid: string,
  plan: TPlan,
) => {
  const response = await fetch(
    `${billingBaseUrl}/${clinicUuid}/update-subscription`,
    {
      method: "PATCH",
      headers: buildHeaders(apiKey),
      body: JSON.stringify({ plan }),
    },
  );

  if (!response.ok) {
    const message = await extractErrorMessage(response);
    throw new Error(message);
  }
};
